/**
 * DAL: Track user platform and push notification status
 */
import { supabase } from '@/integrations/supabase/client';
import { Capacitor } from '@capacitor/core';

/**
 * Detect the current platform as stored value
 */
function detectUserPlatform(): string {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') return 'apple';
  if (platform === 'android') return 'android';
  return 'web';
}

/**
 * Update the user's last seen platform and timestamp
 */
export async function updateLastSeenPlatform(userId: string): Promise<void> {
  const platform = detectUserPlatform();
  const { error } = await supabase
    .from('users')
    .update({
      last_seen_platform: platform,
      last_seen_at: new Date().toISOString(),
    } as any)
    .eq('id', userId);

  if (error) {
    console.error('Failed to update last_seen_platform:', error);
  }
}

/**
 * Update the user's push notification permission status
 */
export async function updatePushNotificationStatus(userId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('users')
    .update({ push_notifications_enabled: enabled } as any)
    .eq('id', userId);

  if (error) {
    console.error('Failed to update push_notifications_enabled:', error);
  }
}
